import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=1ef2b50d&scoped=true"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"
import style0 from "./popup.vue?vue&type=style&index=0&id=1ef2b50d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2b50d",
  null
  
)

export default component.exports